import React from 'react';

interface ShimmerAvatarProps {
  size?: number;
  className?: string;
}

const ShimmerAvatar: React.FC<ShimmerAvatarProps> = ({
  size = 96,
  className = ""
}) => {
  return (
    <div
      className={`rounded-full bg-slate-200 dark:bg-zink-600 ${className}`}
      style={{
        width: size,
        height: size,
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite'
      }}
    />
  );
};

export default ShimmerAvatar;